import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { Button } from "#components/atoms/Button/Button";
import { Text } from "#components/atoms/Typographies/Text";
import { Title } from "#components/atoms/Typographies/Title";
import { Page } from "#components/templates/Page/Page";
import { Icon } from "#shared/icons/Icon";
import { ROUTES } from "#shared/routes";
import { Center } from "#shared/view/components/Center";
import { Stack } from "#shared/view/components/Stack";

const ICON_CONTAINER_SIZE = 32;

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Page>
      <Page.Header />
      <Page.Content>
        <Center h="100%" w="100%">
          <Stack gap={spacing[6]} align="center" maw={420}>
            <Icon
              name="circleFillError"
              size={ICON_CONTAINER_SIZE}
              color={colors.icon.errorDefault}
            />

            <Stack gap={spacing[2]} align="center">
              <Title size="tiny">{t("notFound.title")}</Title>
              <Text size="small" color={colors.text.secondaryDefault} textAlign="center">
                {t("notFound.description")}
              </Text>
            </Stack>

            <Button variant="secondary" onClick={() => navigate(ROUTES.v2QuoteRequests)}>
              {t("notFound.backToHome")}
            </Button>
          </Stack>
        </Center>
      </Page.Content>
    </Page>
  );
};
